const MovePaymentsView = () =>
  import('@/views/DataAdmin/MovePaymentsView/MovePaymentsView')
const MergeAccountsView = () =>
  import('@/views/DataAdmin/MergeAccountsView/MergeAccountsView')
const MergeCustomersView = () =>
  import('@/views/DataAdmin/MergeCustomersView/MergeCustomersView')

export default [
  {
    path: '/customers/move-payment',
    component: MovePaymentsView,
    name: 'MovePaymentsView'
  },
  {
    path: '/tools/merge-accounts',
    component: MergeAccountsView,
    name: 'MergeAccountsView',
    // Reads core's admin merchant list, whose gateway scope admits super tenants only. Without
    // this a merchant user reaching the tool by URL gets a 403 and a blank picker; the guard in
    // router/index.js turns it into a redirect instead.
    meta: { require_roles: ['super_admin'] }
  },
  {
    path: '/tools/merge-customers',
    component: MergeCustomersView,
    name: 'MergeCustomersView',
    // Reads core's admin merchant list, whose gateway scope admits super tenants only. Without
    // this a merchant user reaching the tool by URL gets a 403 and a blank picker; the guard in
    // router/index.js turns it into a redirect instead.
    meta: { require_roles: ['super_admin'] }
  }
]
